import { useCallback, useEffect, useState } from 'react';

export function VideoIconButton({ onClick, label = 'Watch explainer' }) {
  return (
    <button
      type="button"
      className="video-icon-btn"
      title={label}
      aria-label={label}
      onClick={(e) => { e.stopPropagation(); onClick(); }}
    >
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <polygon points="5,3.5 13,8 5,12.5" fill="currentColor" />
      </svg>
    </button>
  );
}

export function VideoPopup({ video, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!video) return null;
  const { eyebrow, title, duration = '02:18', chapter = '01', description, chips = [] } = video;

  return (
    <div className="video-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label={`Video · ${title}`}>
      <div className="video-modal" onClick={(e) => e.stopPropagation()}>

        <div className="video-modal-head">
          <div>
            <div className="eyebrow">{eyebrow} · Explainer</div>
            <h2>{title}</h2>
            <div className="meta">CHAPTER {chapter} · {duration} · COACH NARRATION</div>
          </div>
          <button className="video-modal-close" onClick={onClose} aria-label="Close video">×</button>
        </div>

        <div className="video-modal-stage">
          <div className="vm-frame" aria-hidden="true" />
          <span className="vm-corner tl">REC ●</span>
          <span className="vm-corner tr">{duration}</span>
          <span className="vm-corner bl">{eyebrow}</span>
          <span className="vm-corner br">CH {chapter}</span>
          <div className="vm-center">
            <div>
              <button className="vm-play" aria-label="Play video" onClick={(e) => e.stopPropagation()}>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <polygon points="7,4 21,12 7,20" fill="currentColor" />
                </svg>
              </button>
              <div className="vm-title">{title}</div>
              <div className="vm-sub">Tap to play · {duration}</div>
            </div>
          </div>
          <div className="vm-progress" aria-hidden="true" />
        </div>

        <div className="video-modal-foot">
          <div className="vm-desc">{description}</div>
          <div className="vm-chips">
            {chips.map((c) => <span key={c} className="chip muted">{c}</span>)}
          </div>
        </div>

      </div>
    </div>
  );
}

export function useVideoPopup() {
  const [video, setVideo] = useState(null);
  const open = useCallback((v) => setVideo(v), []);
  const close = useCallback(() => setVideo(null), []);
  const render = () => <VideoPopup video={video} onClose={close} />;
  return { video, open, close, render };
}
